module.exports = __webpack_public_path__ + "img/ctrl-u3-1.b75e9a43.svg";